import {
  JsonSchemaItems,
  RowDataReducerActionPayload,
  RowDataReducerState,
} from "../../../types";

export const updateSchemaPropertyField = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const {
    propertyKey,
    propertyField,
    newPropertyFieldValue,
    rowIndex,
    propertySubKey,
  } = payload;

  if (
    !propertyKey ||
    propertyField === undefined ||
    newPropertyFieldValue === undefined
  ) {
    return state;
  }

  const property = state.schema.properties[propertyKey];

  if (rowIndex !== undefined && propertySubKey !== undefined) {
    const items = property.items as JsonSchemaItems;
    const existingRowScopedProps = items.rowScopedProperties?.[rowIndex] || {};
    const existingSubKeyProps = existingRowScopedProps[propertySubKey] || {};
    const baseSubKeyProps = items?.properties?.[propertySubKey] || {};

    // Found a case where we shouldn't directly update the properties when dealing with rowScopedProperties. Instead, we should update the specific row's scoped properties to ensure that changes only affect the intended row and not all rows sharing the same propertySubKey.
    // const updateProperties = {
    //   ...items.properties,
    //   [propertySubKey]: {
    //     ...baseSubKeyProps,
    //     [propertyField]: newPropertyFieldValue,
    //   },
    // };

    const updatedRowScopedProperties = {
      ...items.rowScopedProperties,
      [rowIndex]: {
        ...existingRowScopedProps,
        [propertySubKey]: {
          ...baseSubKeyProps,
          ...existingSubKeyProps,
          [propertyField]: newPropertyFieldValue,
        },
      },
    };

    return {
      ...state,
      schema: {
        ...state.schema,
        properties: {
          ...state.schema.properties,
          [propertyKey]: {
            ...property,
            items: {
              ...items,
              // properties: updateProperties,
              rowScopedProperties: updatedRowScopedProperties,
            },
          },
        },
      },
    };
  }

  if (propertySubKey !== undefined) {
    const items = property.items as JsonSchemaItems;
    const baseSubKeyProps = items?.properties?.[propertySubKey] || {};

    const updateProperties = {
      ...items.properties,
      [propertySubKey]: {
        ...baseSubKeyProps,
        [propertyField]: newPropertyFieldValue,
      },
    };

    return {
      ...state,
      schema: {
        ...state.schema,
        properties: {
          ...state.schema.properties,
          [propertyKey]: {
            ...property,
            items: {
              ...items,
              properties: updateProperties,
            },
          },
        },
      },
    } as RowDataReducerState;
  }

  const updatedProperties = {
    ...state.schema.properties,
    [propertyKey]: {
      ...property,
      [propertyField]: newPropertyFieldValue,
    },
  };

  return {
    ...state,
    schema: {
      ...state.schema,
      properties: updatedProperties,
    },
  };
};
